import PropTypes from "prop-types";
import { useState } from "react";
import { Col, FormGroup, Input, Row } from "reactstrap";

import { H4, P } from "../../../../../../AbstractElements";
import {
  ALL_COURSE_FILTER_STATUS,
  courseTypeMap,
  EXPERTISE_LEVEL_STATUS,
} from "../../../../../../Api/constants";
import FilterSliderModal from "../../../../../../CommonElements/FilterSliderModal";
import LabelTooltip from "../../../../../../CommonElements/LabelTooltip";
import MultiSelectDropdown from "../../../../../../CommonElements/MultiSelectDropdown";
import LearningPlanCreationCourseCard from "../../../../../../container/LearningPlanCourseCreationCard";
import NoData from "../../../../../../container/NoData";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";
import { getCourseList } from "../../../../../../ReduxToolkit/Reducers/CourseSlice";
import {
  Courses,
  Assessments,
  FilterBy,
  NoDataText,
  Select,
  FindCourses,
  FindAssessments,
  CourseType,
  Domain,
  MandatoryNote,
} from "../../../../../../utils/Constant";
import {
  courseFilterDropdownList,
  learningPlanCreationOptions,
} from "../../../../../../utils/helper/helper";

const AddCoursesOrAssessment = ({
  courses,
  setCourses,
  assessments,
  setAssessments,
  preSelectedCoursesIds,
  setPreSelectedCoursesIds,
  preSelectedAssessmentIds,
  setPreSelectedAssessmentIds,
  courseListData,
  assesmentCatlog,
  domainListData,
}) => {
  const dispatch = useAppDispatch();
  const [filterBy, setFilterBy] = useState("courses");
  const [preSelectedCourses, setPreSelectedCourses] = useState([]);
  const [preSelectedAssessments, setPreSelectedAssessments] = useState([]);
  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const [defaultFilterValues, setDefaultFilterValues] = useState({});

  const handleToggleMandatoryCourse = (id: number) => {
    setCourses(prev =>
      prev.map(course =>
        course.id === id
          ? { ...course, isMandatory: !course.isMandatory }
          : course
      )
    );
  };

  const handleDeleteCourse = (id: number) => {
    setPreSelectedCoursesIds(prev => prev.filter(pre => pre !== id));
    setCourses(prev => prev.filter(course => course.id !== id));
  };

  const handleToggleMandatoryAssessment = (id: number) => {
    setAssessments(prev =>
      prev.map(assessment =>
        assessment.id === id
          ? { ...assessment, isMandatory: !assessment.isMandatory }
          : assessment
      )
    );
  };

  const handleDeleteAssessment = (id: number) => {
    setPreSelectedAssessmentIds(prev => prev.filter(pre => pre !== id));
    setAssessments(prev => prev.filter(assessment => assessment.id !== id));
  };

  const setMultiDropdownData = (value: any[]) => {
    if (filterBy === "courses") {
      const coursesMap = [];
      courseListData?.forEach((element: any) => {
        if (value.includes(element.name)) {
          coursesMap.push({
            name: element.name,
            value: element.label,
            label: element.label,
            type: element?.type,
            actual_duration: element?.actual_duration,
          });
        }
      });
      setPreSelectedCourses(coursesMap);
    }

    if (filterBy === "assessments") {
      const assessmentMap = [];
      assesmentCatlog?.forEach((element: any) => {
        if (value.includes(element.name)) {
          assessmentMap.push({
            name: element.name,
            value: element.label,
            label: element.label,
            question: element?.question,
            actual_duration: element?.actual_duration,
          });
        }
      });
      setPreSelectedAssessments(assessmentMap);
    }
  };

  const handleDone = async (values: { [key: string]: string[] }) => {
    const { course_type = ALL_COURSE_FILTER_STATUS, domain = [] } = values;
    await dispatch(
      getCourseList({
        status: EXPERTISE_LEVEL_STATUS,
        course_type:
          course_type.length > 0 ? course_type : ALL_COURSE_FILTER_STATUS,
        domain: domain.length > 0 ? domain : null,
      })
    );
  };

  const handleClear = async () => {
    await dispatch(
      getCourseList({
        status: EXPERTISE_LEVEL_STATUS,
        course_type: ALL_COURSE_FILTER_STATUS,
        domain: null,
      })
    );
    setSelectedFilterValues({});
    setDefaultFilterValues({});
  };

  return (
    <div className="p-2">
      <Row>
        <Col lg="2" md="2" sm="12" xs="12">
          <FormGroup>
            <LabelTooltip
              label={FilterBy}
              tooltipText={FilterBy}
              important={false}
            />
            <Input
              onChange={e => {
                setFilterBy(e.target.value);
              }}
              value={filterBy}
              type="select"
            >
              {learningPlanCreationOptions?.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col lg="10" md="10" sm="12" xs="12">
          {filterBy === "courses" && (
            <div className="d-flex gap-2">
              <FormGroup className="w-50">
                <LabelTooltip
                  label={FindCourses}
                  tooltipText={FindCourses}
                  important
                />
                <MultiSelectDropdown
                  onChange={setMultiDropdownData}
                  onBlurDropdown={values => {
                    const selected = [];
                    const selectedIds = [];
                    values?.map(item => {
                      selectedIds.push(item?.name);
                      selected.push({
                        id: item?.name,
                        mode: item?.type,
                        title: item?.label,
                        isMandatory: false,
                        duration: item?.duration,
                        actual_duration: item?.actual_duration,
                      });
                    });
                    setPreSelectedCoursesIds([
                      ...preSelectedCoursesIds,
                      ...selectedIds,
                    ]);
                    setCourses([...courses, ...selected]);
                    setPreSelectedCourses([]);
                  }}
                  options={courseListData?.filter(
                    item => !preSelectedCoursesIds?.includes(item?.name)
                  )}
                  placeholder={`${Select} ${Courses}`}
                  defaultSelected={preSelectedCourses}
                />
              </FormGroup>
              <div className="filter-margin">
                <FilterSliderModal
                  dropdowns={[
                    {
                      label: CourseType,
                      key: "course_type",
                      tooltipText: `${Select} ${CourseType}`,
                      options: courseFilterDropdownList,
                      isMultiSelect: true,
                    },
                    {
                      label: Domain,
                      key: "domain",
                      tooltipText: `${Select} ${Domain}`,
                      options: domainListData,
                      isMultiSelect: true,
                    },
                  ]}
                  selectedFilterValues={selectedFilterValues}
                  defaultFilterValues={defaultFilterValues}
                  setSelectedFilterValues={setSelectedFilterValues}
                  setDefaultFilterValues={setDefaultFilterValues}
                  onDone={handleDone}
                  onClear={handleClear}
                />
              </div>
            </div>
          )}
          {filterBy === "assessments" && (
            <FormGroup className="w-50">
              <LabelTooltip
                label={FindAssessments}
                tooltipText={FindAssessments}
                important={false}
              />
              <MultiSelectDropdown
                onChange={setMultiDropdownData}
                onBlurDropdown={values => {
                  const selected = [];
                  const selectedIds = [];
                  values?.map(item => {
                    selectedIds.push(item?.name);
                    selected.push({
                      id: item?.name,
                      mode: item?.question,
                      title: item?.label,
                      isMandatory: false,
                      duration: item?.duration,
                      actual_duration: item?.actual_duration,
                    });
                  });
                  setPreSelectedAssessmentIds([
                    ...preSelectedAssessmentIds,
                    ...selectedIds,
                  ]);
                  setAssessments([...assessments, ...selected]);
                  setPreSelectedAssessments([]);
                }}
                options={assesmentCatlog?.filter(
                  item => !preSelectedAssessmentIds?.includes(item?.name)
                )}
                placeholder={`${Select} ${Assessments}`}
                defaultSelected={preSelectedAssessments}
              />
            </FormGroup>
          )}
        </Col>
      </Row>
      <H4 className="text-xl fw-bold mb-2 mt-3">{Courses}</H4>
      <Row>
        {courses?.length > 0 ? (
          courses.map((course, ind) => (
            <Col lg="4" md="4" xs="12" sm="12" key={course.id}>
              <LearningPlanCreationCourseCard
                id={"course-" + ind}
                mode={courseTypeMap[course.mode]}
                title={course.title}
                isMandatory={course.isMandatory}
                onToggleMandatory={() => handleToggleMandatoryCourse(course.id)}
                onDelete={() => handleDeleteCourse(course.id)}
              />
            </Col>
          ))
        ) : (
          <NoData
            svg={"empty-folder-icon"}
            title={NoDataText}
            showCard={false}
          />
        )}
      </Row>

      <H4 className="text-xl fw-bold mb-2">{Assessments}</H4>
      <Row>
        {assessments?.length > 0 ? (
          assessments.map((assessment, ind) => (
            <Col lg="4" md="4" xs="12" sm="12" key={assessment.id}>
              <LearningPlanCreationCourseCard
                id={"assessment-" + ind}
                mode={assessment.mode}
                title={assessment.title}
                isMandatory={assessment.isMandatory}
                onToggleMandatory={() =>
                  handleToggleMandatoryAssessment(assessment.id)
                }
                onDelete={() => handleDeleteAssessment(assessment.id)}
              />
            </Col>
          ))
        ) : (
          <NoData
            svg={"empty-folder-icon"}
            title={NoDataText}
            showCard={false}
          />
        )}
      </Row>
      {(courses?.length > 0 || assessments?.length > 0) && (
        <P>{MandatoryNote}</P>
      )}
    </div>
  );
};

export default AddCoursesOrAssessment;

AddCoursesOrAssessment.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      mode: PropTypes.string.isRequired,
      isMandatory: PropTypes.bool.isRequired,
    })
  ).isRequired,
  setCourses: PropTypes.func.isRequired,

  assessments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      mode: PropTypes.string.isRequired,
      isMandatory: PropTypes.bool.isRequired,
    })
  ).isRequired,
  setAssessments: PropTypes.func.isRequired,

  preSelectedCoursesIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  setPreSelectedCoursesIds: PropTypes.func.isRequired,

  preSelectedAssessmentIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  setPreSelectedAssessmentIds: PropTypes.func.isRequired,

  courseListData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string,
    })
  ).isRequired,

  assesmentCatlog: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      question: PropTypes.string,
    })
  ).isRequired,

  domainListData: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};
